/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Edit_Avatar_UrlInputs */

const en_forms_users_edit_avatar_url = /** @type {(inputs: Forms_Users_Edit_Avatar_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Url`)
};

const de_forms_users_edit_avatar_url = /** @type {(inputs: Forms_Users_Edit_Avatar_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

/**
* | output |
* | --- |
* | "Url" |
*
* @param {Forms_Users_Edit_Avatar_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_edit_avatar_url = /** @type {((inputs?: Forms_Users_Edit_Avatar_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Edit_Avatar_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_edit_avatar_url(inputs)
	return de_forms_users_edit_avatar_url(inputs)
});